import './App.css';
import { memo, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

export const App = memo(() => {
  const params = useParams();
  const [platform, setPlatform] = useState('');
  useEffect(() => {
    const { name } = params;
    if(name) {
      const capitalize = name.charAt(0).toUpperCase() + name.slice(1);
      setPlatform(capitalize);
    } else {
      setPlatform('FullCam');
    }
  },[]);
  return (
      <div className="terms">
        <div>
          <div>
            <h1>Política de Privacidade {platform}</h1>
            <small>Última alteração: 10 de Junho de 2019</small>
          </div>
          <br/>
          <h3>1. Informações que nós coletamos</h3>
          <br/>
          O {platform} recebe ou coleta informações quando operamos e fornecemos nossos serviços, inclusive quando você instala,
          acessa ou usa nossos serviços.
          <h4>1.1 Informações que você fornece</h4>
          <h4>1.1.1 Informações de conta</h4>
          Você fornece uma conta {platform} previamente cadastrada na plataforma. Esse conta será usada para acessar todos os serviços da plataforma {platform}.
          <h4>1.2 Informações que coletamos automaticamente</h4>
          <h4>1.2.1 Informações de log e uso do serviço</h4>
          Usamos a ferramenta de análise e coleta de dados do uso do aplicativo a fim de melhorar a usabilidade do {platform}.
          <h4>1.2.2 Informações de conexão e do dispositivo</h4>
          Usamos as informações de conexão de seu dispositivo para melhorar a experiência de uso em casos de má conexão com sua rede
          de dados. As informações do dispositivo são coletadas para análise do nosso público-alvo a fim de melhorar a usabilidade
          do {platform}.
          <h4>1.3 Gerenciando suas informações</h4>
          Se você gostaria de gerenciar, alterar, limitar ou excluir suas informações, nós permitimos que você faça isso através da
          plataforma de video monitoramento do {platform}, disponível para todos os usuários {platform}.
          <h4>1.4 Atualizações da nossa política</h4>
          Podemos alterar ou atualizar nossa Política de Privacidade. Forneceremos o aviso de alterações a esta Política de Privacidade,
          conforme apropriado, e atualizaremos a data "Última Modificação" no topo desta Política de Privacidade. O uso continuado
          dos nossos serviçoes confirma a sua aceitação da nossa Política de Privacidade, conforme alterada. Se você não concordar
          com nossa Política de Privacidade, conforme alterada, você deve parar de usar nossos serviços. Por favor reveja nossa Política
          de Privacidade de tempos em tempos.
        </div>
      </div>
  );
});